'use client';

import React, { useCallback, useState } from "react";
import ClientComponent from "./client_component";
import { AppBar, Box, Divider, IconButton, List, ListItem, ListItemText, Stack, Toolbar, Typography } from "@mui/material";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import BuilderSelct from "@/store/builderStoreSelector";
import { CardActionArea } from '@mui/material';
import { RoomModel } from "@/store/builderSlice";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';

export interface RoomModelsListProps {
    models: RoomModel[];
    onRoomModelSelected: Function;
    selectedRoomId: string;
}


const RoomModelsList = (props: RoomModelsListProps) => {

    const onModelSelected = useCallback((roomModel: RoomModel) => () => {
        console.log('clicked ID: ', roomModel.roomId);
        props.onRoomModelSelected(roomModel);
    }, []);

    const roomType = props.models && props.models.length > 0 ? props.models[0].roomType : '';

    const roomModelsList = () => {
        const modelListComps: JSX.Element[] = [];
        props.models.forEach(roomModel => {
            const isActiveRoomModel = props.selectedRoomId === roomModel.roomId;
            modelListComps.push(
                <ListItem>
                    <Card id={roomModel.roomId}
                        sx={{
                            maxWidth: 345,
                            border: isActiveRoomModel ? '2px solid #DC7633' : ''
                        }}>
                        <CardActionArea onClick={onModelSelected(roomModel)}>
                            <CardMedia
                                sx={{ height: 150, width: 150 }}
                                image={roomModel.thumbnail}
                                title={roomModel.roomName}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5" component="div">
                                    {decodeURIComponent(roomModel.roomLabel)}
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </ListItem>
            );
        });
        return (
            <List component={Stack} direction="row">
                {modelListComps}
            </List>
        );
    }

    return (
        <List>
            <ListItem>
                <ListItemText
                    primaryTypographyProps={{ fontSize: '18px', fontWeight: "fontWeightMedium" }}
                    primary={roomType}
                />
            </ListItem>
            <ListItem>
                {roomModelsList()}
            </ListItem>
        </List>
    )
}

export default ClientComponent(RoomModelsList);